var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full"},[_c('cardTitle',{attrs:{"title":"今日风险作业管控情况","cardType":"shimen"}}),_c('v-chart',{staticClass:"!h-[calc(100%-62px)] !w-full",attrs:{"options":_vm.riskyOperations,"autoresize":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }